import { Body, Headline } from "~/ui-library";
import NextImage from "next/image";

export type SubCheckoutHeaderProps = {
  headline: string;
  bodyText: string | null;
  showImage: boolean;
};

export const SubCheckoutHeader: React.FC<SubCheckoutHeaderProps> = ({
  headline,
  bodyText,
  showImage,
}) => (
  <div className="flex flex-col items-center justify-center">
    {showImage ? (
      <NextImage
        width={304}
        height={171}
        src="/assets/free-trial-vp-3.png"
        alt="checkout-header"
      />
    ) : null}
    <div className="bg-white">
      <Headline as="h2" level={3} className="text-center">
        {headline}
      </Headline>
      {bodyText ? (
        <Body
          as="p"
          className="mt-xs text-center"
          data-testid="body-text"
          size="default"
        >
          {bodyText}
        </Body>
      ) : null}
    </div>
  </div>
);
